export function Spinner() {
  return <div className="spinner" role="status" aria-label="Cargando" />;
}
